module.exports = __webpack_public_path__ + "media/2-71.f22ae66c.wav";